export const HERO_SECTION_COPY = {
  mainHeadingLine1: 'Is Gousto worth it?',
  mainHeadingLine2: "Here's how it works",
  descriptionParagraph1:
    "Not sure if Gousto's for you? Find out how our food boxes make cooking at home easier and tastier than ever.",
  ctaButtonText: "Explore this week's menu",
}
